/**
 * Data privacy checklist for quiz-style UX, e.g. onboarding quiz, also applicable to special pages like period calculator.
 *   - Does the quiz state or imply sensitive data? If yes, next items?
 *      - E.g. Cycle length, medical conditions, contraceptive choice
 *   - Do we need marketing pixels on this page?
 *      - If it’s not a high-value page, the simplest solution can be to add the page to “SMMS exclusion list” to disable triggering of pixels altogether. E.g.Most pages in the on-boarding quiz are excluded based on this necessity test.
 *      - If it is a high-value page, we need to perform some extra checks to confirm that sensitive data is not being shared
 *          - Avoid having title / URL of next page being the answer of the question on the previous page as that is generally shared with pixels
 *          - Inspect pixel behavior (e.g. using network tab) to confirm that sensitive data is not sent.
 *            - Confirm that clicked button captions (text) is not sent - NC pixels should NOT capture button copy
 */
export const domainPathKeywordSuppressionMap = {
  'https://www.naturalcycles.com/': ['shop', 'research-library', 'plan-pregnancy', 'postpartum', 'cyclematters/period-calculator'],
  'https://signup.naturalcycles.com/': ['account', 'onboarding']
};
export const debugDomainMap = {
  'http://localhost:8000': 'https://www.naturalcycles.com/',
  'http://localhost:4200': 'https://signup.naturalcycles.com/'
};
export const allowedDomains = ['https://www.naturalcycles.com/', 'https://signup.naturalcycles.com/'];